import { render, staticRenderFns } from "./AnalysisQuizList.vue?vue&type=template&id=73fa1c78"
import script from "./AnalysisQuizList.vue?vue&type=script&lang=js"
export * from "./AnalysisQuizList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports